module.exports = __webpack_public_path__ + "img/brackets.57e403d0.svg";